import styled from 'styled-components';

const ODDLY_EMPTY_STATE_SPACER_HEIGHT = '200px';

export const TopSpacer = styled.div`
  height: ${ODDLY_EMPTY_STATE_SPACER_HEIGHT};
`;

export const EmptyStateContainer = styled.div`
  text-align: center;

  ${props =>
    props.centered &&
    `
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
    `}
`;

export const ButtonsContainer = styled.div``;
